// extracted by mini-css-extract-plugin
export default {"viewContainer":"TenantsManagementView_viewContainer__35HKn"};